import ShimmerLogo from "../ShimmerLogo/ShimmerLogo";
import "./Ai.style.scss";

import React from "react";

function Ai(props) {
	const createMarkup = () => {
		return { __html: props.children };
	};

	return (
		<div className='ai-container'>
			{props.loading ? (
				<ShimmerLogo />
			) : (
				<div className='ai-response'>
					<div dangerouslySetInnerHTML={createMarkup()} />
				</div>
			)}
		</div>
	);
}

export default Ai;
